export default __webpack_public_path__ + "static/media/FbLogo.9aacc2ea.ico";